<template>
    <div>
        <el-card>
    <el-table :data="tableData" size=mini highlight-current-row v-loading="loading" :header-cell-style = "{background:'#987AFF'}" @current-change="handleCurrentChange" height='600' element-loading-text="拼命加载中">
    <el-table-column type="index" width="90" />
    <el-table-column property="type" label="扣款类型" width="180" />
    <el-table-column property="amount" label="扣款金额" width="157" :show-overflow-tooltip="true" />
    <el-table-column property="flow_use" label="结算水量" width="180" :show-overflow-tooltip="true" />
    <el-table-column property="create_time" label="扣款时间" width="200" :show-overflow-tooltip="true" />
    <el-table-column property="note" label="备注" width="150" />
  </el-table>
      </el-card>
    </div>
</template>

<script>
export default {
  data () {
    return {
    // table数据
      tableData: [{
        type: null,
        amount: null,
        create_time: null,
        note: null
      }],
      // tab数据加载转圈
      loading: false,
      recsDatas: {
        project_id: null,
        token: null,
        meter_id: null
      }
    }
  },
  created () {
    this.recsDatas.project_id = this.$store.state.print.goodsForeNo.project_id
    this.recsDatas.token = this.$store.state.print.goodsForeNo.token
    this.recsDatas.meter_id = this.$parent.meterid
    console.log(this.recsDatas.meter_id, '父组件的meterid扣款记录')
    this.recsData()
  },
  methods: {
    recsData () {
      this.$api.userProfile.waterChargesRecord(this.recsDatas).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '扣款记录')
          this.tableData = res.data.data
        }
      })
    },
    // tab组件
    handleCurrentChange (val) {
    }
  }
}
</script>

<style lang="less" scoped>
.el-card{
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table tr{
            background-color: #F9F9F9;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
        }
</style>
